import { Widget } from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { Utils } from '../../../../../../../utils/utils';
import { WidgetChartOptions } from '../../../../widget-chart/widget-chart.component';
import { AiSummaryTranslocoParameters } from './widget-ai-insights-summary.service';

export default class BreakdownSummaryParameters implements AiSummaryTranslocoParameters {
  assembleParameters(selectedPoints: any[], widget: Widget<WidgetChartOptions>) {
    let previousScoring;

    return selectedPoints.map((p) => {
      const breakdownPayload = widget.payload[p.series.options.custom.payloadProp];
      let scoring = breakdownPayload.scoring.toLocaleUpperCase();
      if (breakdownPayload.numericMetadataFieldId === 'docs') {
        scoring = 'COUNT';
      }

      let translationKey = `widgets.ai-insights.summary.${widget.payload.type}.${scoring}`;

      let boxSize;
      if (scoring === 'BOX') {
        const boxType = p.series.options.custom.box;
        translationKey = `${translationKey}.${boxType}`;
        if (boxType === 'top') {
          boxSize = breakdownPayload.topBoxSize;
        }
        if (boxType === 'bottom') {
          boxSize = breakdownPayload.bottomBoxSize;
        }
      }

      translationKey = `${translationKey}.${
        scoring !== previousScoring ? 'first-point' : 'rest-of-points'
      }`;
      previousScoring = scoring;

      return {
        translationKey,
        translationParams: {
          boxSize,
          fieldName: FieldService.getFieldLongName(breakdownPayload.numericMetadataFieldId),
          fieldValue: p.pointId,
          score: Utils.round(p.y),
        },
      };
    });
  }
}
